// import XEUtils from 'xe-utils';
import MERCHANTAPI from '@/api/property/merchantCenter';
import XEUtils from 'xe-utils';
export default {
  data() {
    return {
      id: null,
      initialLoad: true,
      baseInfoData: {
        nicheCompanyNo: null,
        nicheCompanyName: null,
        nicheDepartmentCode: null,
        nicheDepartmentName: null,
        customerCode: null,
        customerName: null,
        //意向金
        intentionAmount: null,
        contactPerson: null,
        contactPhone: null,
        //商机过程
        nicheProcess: null,
        nicheNo: null,
        nicheStatus: null,
        entryStatus: null,
        entryDate: null,
        createPersonName: null,
        gmtCreate: null,
      },
      signInfoData: {
        merchantContactPerson: null,
        merchantContactPhone: null,
        relatedContractNo: null,
        relatedContractStatus: null,
        leaseRentAmount: null,
      },
      nicheSignUpSpaces: [],
      nicheIntentSpaces: [],
      nicheFollowRecords: [],
    };
  },
  methods: {
    changeValueHandler({ val, prop }) {
      console.log('valueChanged', val, prop);
      if (prop == 'customerCode') {
        if (val && val[0]) {
          this.baseInfoData.customerName = val[0].partnerZhName;
          this.baseInfoData.customerCode = val[0].partnerCode;
        }
      }
    },
    // 切换公司
    changeCompanyHandler({ val }) {
      let item = XEUtils.find(
        JSON.parse(this.userInfo.companyList),
        (item) => item['personCompanyCode'] === val
      );
      this.baseInfoData = {
        ...this.baseInfoData,
        nicheCompanyNo: item.personCompanyCode,
        nicheCompanyName: item.personCompanyName,
      };

      if (this.initialLoad) {
        this.initialLoad = false;
      } else {
        this.baseInfoData.nicheDepartmentCode = null;
        this.baseInfoData.nicheDepartmentName = null;
      }
      console.log('company changed', val);
    },
    // 切换部门
    changeDepartmentHandler({ val }) {
      this.baseInfoData = {
        ...this.baseInfoData,
        nicheDepartmentCode: val.createDepartmentCode,
        nicheDepartmentName: val.createDepartmentName,
      };
    },
    handleTableChange(tableName, data) {
      if (tableName == 'desiredSpace') {
        this.nicheIntentSpaces = data;
      } else if (tableName == 'followingRecords') {
        this.nicheFollowRecords = data;
      }
    },
    async initDetail() {
      // this.baseColumns = this.getProcessedBaseColumns();
      if (this.$route.query?.id) {
        this.id = this.$route.query?.id;
        var res = await this.$axios.get(MERCHANTAPI.VIEW_DETAIL + this.id);
        if (res.data.code == 0) {
          const {
            nicheCompanyName,
            nicheCompanyNo,
            nicheDepartmentName,
            nicheDepartmentCode,
            customerCode,
            customerName,
            intentionAmount,
            contactPerson,
            contactPhone,
            nicheProcess,
            nicheIntentSpaces,
            nicheFollowRecords,
          } = res.data.data;

          this.baseInfoData = {
            ...this.baseInfoData,
            nicheCompanyName,
            nicheCompanyNo,
            nicheDepartmentName,
            nicheDepartmentCode,
            customerCode,
            customerName,
            intentionAmount,
            contactPerson,
            contactPhone,
            nicheProcess,
          };

          if (this.pageMode == 1) {
            const { nicheNo, nicheStatus, entryStatus, entryDate, createPersonName, gmtCreate } =
              res.data.data;
            this.baseInfoData = {
              ...this.baseInfoData,
              nicheNo,
              nicheStatus,
              entryStatus,
              entryDate,
              createPersonName,
              gmtCreate,
            };
          }

          this.nicheIntentSpaces = nicheIntentSpaces;
          this.nicheFollowRecords = nicheFollowRecords;

          //签约信息
          const {
            merchantContactPerson,
            merchantContactPhone,
            relatedContractNo,
            relatedContractStatus,
            leaseRentAmount,
            nicheSignUpSpaces,
          } = res.data.data;

          this.signInfoData = {
            ...this.signInfoData,
            merchantContactPerson,
            merchantContactPhone,
            relatedContractNo,
            relatedContractStatus,
            leaseRentAmount,
          };
          this.nicheSignUpSpaces = nicheSignUpSpaces;
        } else {
          this.$message.error(res.data.msg);
        }
      } else {
        this.baseInfoData.nicheCompanyName = this.userInfo.companyName;
        this.baseInfoData.nicheCompanyNo = this.userInfo.companyCode;
        this.baseInfoData.nicheDepartmentCode = this.userInfo.departmentCode;
        this.baseInfoData.nicheDepartmentName = this.userInfo.departmentName;
      }
    },
    async btnClick(type) {
      if (type == 'cancel') {
        this.$confirmAction('', '确认取消吗？\n 已输入的内容将不会被保存！')
          .then(() => {
            let name = 'merchantCreate';
            let suffix = 'create';

            if (this.pageMode == 1) {
              suffix = 'detail';
              name = 'merchantDetail';
            } else if (this.pageMode == 2) {
              suffix = 'edit';
              name = 'merchantEdit';
            }

            let path = {
              path: `/property/merchant/center/${suffix}`,
              name: name,
              meta: {
                keepAlive: false,
                title: this.$route.query?.id ? '编辑商机' : '新增商机',
              },
            };
            this.$store.dispatch('tagsView/delView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push('/property/merchant/center/overview');
              });
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
      } else if (type == 'save') {
        await this.$refs.baseInfoFormRef.getValidateFormData();

        // const desiredSpaceError = await this.$refs.desiredTableRef.$refs.desiredSpaceTableRef
        //   .validate()
        //   .catch((errMap) => errMap);
        // if (desiredSpaceError) {
        //   this.$message.error('请检查数据再提交');
        //   return;
        // }

        // const followingRecordsError =
        //   await this.$refs.followingTableRef.$refs.followingRecordsTableRef
        //     .validate()
        //     .catch((errMap) => errMap);
        // if (followingRecordsError) {
        //   this.$message.error('请检查数据再提交');
        //   return;
        // }

        await this.$refs.desiredTableRef.closeEditTableHandler();
        await this.$refs.followingTableRef.closeEditTableHandler();

        let params = { ...this.baseInfoData };

        delete params.nicheNo;
        delete params.nicheStatus;
        delete params.entryStatus;
        delete params.entryDate;
        delete params.createPersonName;
        delete params.gmtCreate;

        params.nicheIntentSpaces = this.nicheIntentSpaces;
        params.nicheFollowRecords = this.nicheFollowRecords;
        console.log('submit params', params);

        let api = MERCHANTAPI.SAVE_MERCHANT;
        if (this.pageMode == 2) {
          api = MERCHANTAPI.UPDATE_MERCHANT;
          params.id = this.id;
        }

        this.loading = true;
        const { data } = await this.$axios.post(api, params);
        this.loading = false;

        if (data.code == 0) {
          this.$message.success(data.msg);

          let name = 'merchantCreate';
          let suffix = 'create';

          if (this.pageMode == 1) {
            suffix = 'detail';
            name = 'merchantDetail';
          } else if (this.pageMode == 2) {
            suffix = 'edit';
            name = 'merchantEdit';
          }

          let path = {
            path: `/property/merchant/center/${suffix}`,
            name: name,
            meta: {
              keepAlive: false,
              title: this.$route.query?.id ? '编辑商机' : '新增商机',
            },
          };
          this.$store.dispatch('tagsView/delView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push('/property/merchant/center/overview');
            });
          });
        } else {
          this.$message.error(data.msg);
        }
      }
    },
  },
  mounted() {},
};
